import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Appear after the user scrolls past the hero (~500px)
      setIsVisible(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`md:hidden fixed left-0 right-0 bottom-0 z-40 px-3 pointer-events-none transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`} style={{
    paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))'
  }} aria-hidden={!isVisible} data-id="element-196">
      <div className="pointer-events-auto bg-cream-50/95 backdrop-blur-md border border-cream-300 rounded-2xl shadow-[0_8px_30px_-8px_rgba(31,27,22,0.18)] flex items-center justify-between gap-3 pl-4 pr-1.5 py-1.5" data-id="element-197">
        {/* Left: price + micro detail */}
        <div className="flex flex-col leading-tight min-w-0" data-id="element-198">
          <div className="flex items-baseline gap-1.5" data-id="element-199">
            <span className="font-serif text-lg font-semibold text-ink-900" data-id="element-200">
              $19.990
            </span>
            <span className="text-[10px] text-ink-600 font-medium uppercase tracking-wider" data-id="element-201">
              ARS
            </span>
          </div>
          <p className="text-[11px] text-ink-600 truncate" data-id="element-202">
            300+ remedios · 10 bonos
          </p>
        </div>

        {/* Right: CTA */}
        <a href="https://impulsodigital.vip/cart/44742359646294:1" className="flex-shrink-0 inline-flex items-center gap-1.5 bg-olive-600 hover:bg-olive-700 active:scale-[0.98] text-cream-50 text-sm font-semibold py-3 px-4 rounded-xl transition-all shadow-sm" data-id="element-203">
          <span data-id="element-204">Quiero mi guía</span>
          <ArrowRight className="w-4 h-4" data-id="element-205" />
        </a>
      </div>
    </div>;
}